import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/util';
import {
  CompanyExtended,
  Base64FileFieldRequest,
  PatchedCompanySettingsRequest
} from '@pxtra-client-lib-legacy/gen';
import { enqueueSnackbar } from 'notistack';

export const usePostCompanyLogo = (companyId: string, options = {}) => {
  return useMutation({
    mutationFn: async (logo: Base64FileFieldRequest | null) =>
      await apiClient.companies.companiesSettingsPartialUpdate({
        id: companyId,
        requestBody: {
          logo: logo
        }
      }),
    ...options,
    onSuccess: () => {
      enqueueSnackbar('Änderungen wurden erfolgreich gespeichert', { variant: 'success' });
    },
    onError: (error) => {
      enqueueSnackbar(`Fehler beim Speichern der Änderungen: ${error}`, { variant: 'error' });
    }
  });
};

export function useCompanySettingsPayrollUpdate() {
  return useMutation({
    mutationFn: ({
      lohnart,
      val,
      comp
    }: {
      lohnart: string;
      val: string;
      comp: CompanyExtended['id'];
    }) =>
      apiClient.companies.companiesSettingsPayrollPartialUpdate({
        id: comp,
        requestBody: { [lohnart]: val }
      })
  });
}

export function useCompanySettingsUpdate(options = {}) {
  return useMutation({
    mutationFn: ({
      company,
      settings
    }: {
      company: CompanyExtended['id'];
      settings: PatchedCompanySettingsRequest;
    }) =>
      apiClient.companies.companiesSettingsPartialUpdate({
        id: company,
        requestBody: settings
      }),
    ...options
  });
}

export function useDeleteBenefitSet(options = {}) {
  return useMutation({
    mutationFn: (data: { id: string }) =>
      apiClient.benefits.benefitsBenefitSetsDestroy({
        id: data.id
      }),
    ...options
  });
}
